import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { buildRoute } from 'routes';
import { getPartner } from 'app/features/partners/partnerSaga';
import { hidePartnerBriefDetails } from 'app/features/partners/partnerSlice';
import SourceDetails from 'core/source-detail/SourceDetails';
import Modal from 'app/components/Modal';

function PartnerPreviewDetailsModal() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const viewData = useMemo(
    () => [
      {
        label: 'Partner Name',
        data: 'name',
      },
      {
        label: 'Postal Code',
        data: 'post_code',
      },
      {
        label: 'Address',
        data: 'address',
      },
      {
        label: 'City',
        data: 'city',
      },
      {
        label: 'State',
        data: 'state',
      },
      {
        label: 'Country',
        data: 'country',
      },
      {
        label: 'Currency',
        data: 'currency',
      },
      {
        label: 'Name',
        data: 'cnt_name',
      },
      {
        label: 'Email',
        data: 'cnt_email',
      },
      {
        label: 'Phone Number',
        data: 'cnt_phone_number',
      },
      {
        label: 'Mobile Number',
        data: 'cnt_mobile_number',
      },
    ],
    [],
  );

  const viewColumn = useMemo(
    () => [
      {
        title: '',
        items: [
          { label: 'Partner Name', accessorKey: 'name' },
          { label: 'Postal Code', accessorKey: 'post_code' },
          { label: 'Address', accessorKey: 'address' },
          { label: 'City', accessorKey: 'city' },
          { label: 'State', accessorKey: 'state' },
          { label: 'Country', accessorKey: 'country' },
          { label: 'Currency', accessorKey: 'currency' },
          { label: 'Name', accessorKey: 'cnt_name' },
          { label: 'Email', accessorKey: 'cnt_email' },
          { label: 'Phone Number', accessorKey: 'cnt_phone_number' },
          { label: 'Mobile Number', accessorKey: 'cnt_mobile_number' },
        ],
      },
    ],
    [],
  );

  const state = useSelector((state) => state.partners.show);

  const { showBriefDetailModal, partnerId, isLoading, data, isError } = state;

  useEffect(() => {
    if (partnerId) dispatch(getPartner(partnerId));
  }, [partnerId]);

  if (!showBriefDetailModal && !partnerId) return <></>;

  return (
    // <SidebarBriefModal
    //   open={showBriefDetailModal ?? false}
    //   onClose={() => dispatch(hidePartnerBriefDetails())}
    //   viewData={viewData}
    //   item={data}
    //   isLoading={isLoading}
    //   title="Partner Details"
    //   onClickView={() => (
    //     dispatch(hidePartnerBriefDetails()), navigate(buildRoute('partners.show', partnerId))
    //   )}
    // ></SidebarBriefModal>

    <Modal
      open={showBriefDetailModal ?? false}
      onClose={() => dispatch(hidePartnerBriefDetails())}
      title="Partner Details"
      handleFullDetails={() => (
        dispatch(hidePartnerBriefDetails()), navigate(buildRoute('partners.show', partnerId))
      )}
    >
      <SourceDetails
        showContainerDesign={false}
        definition={viewColumn}
        data={data}
        isLoading={isLoading}
      />
    </Modal>
  );
}

export default PartnerPreviewDetailsModal;
